<template>
  <div class="info-container">
      <div class="column items-center q-gutter-sm q-mb-lg">
        <q-avatar size="84px">
        <img src="@/assets/logo.png" alt="pay-r Logo" />
      </q-avatar>


          <q-btn
            no-caps
            flat
            size="lg"
            color="primary"
            label="Zur Terminauswahl"
            icon-right="arrow_forward_ios"
            to="/de/termin"
          />

      <q-btn
        no-caps
        flat
        size="sm"
        color="primary"
        class="legal-button"
        label="Impressum und Datenschutzerklärung"
        to="/de/datenschutz-impressum"
      />
    </div>
  </div>
</template>

<script setup>
</script>
